<template>
  <div class="replacementmonthlystatistics__report__view">
    <div class="reports__subheader">

      <year-month-panel @year="(value) => year = value"
                        @month="(value) => month = value">
      </year-month-panel>

      <employees-panel @employeeId="value => employeeId = value" :employeeNumber="employeeNumber" v-if="isAdmin">
      </employees-panel>

      <submit-panel @submit="performLookup">
      </submit-panel>

    </div>

    <b-table :data="monthReport"
             :loading="loading">

      <b-table-column field="number" label="Ins. nr." v-slot="props" sortable numeric>
          {{ props.row.number }}
      </b-table-column>

      <b-table-column field="name" label="Inseminør" v-slot="props" sortable>
          {{ props.row.name }}
      </b-table-column>

    </b-table>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import APISTATE from '@/enums/APISTATE';
import SubmitPanel from '@/components/report/SubmitPanel.vue';
import YearMonthPanel from '@/components/report/YearMonthPanel.vue';
import EmployeesPanel from '@/components/report/EmployeesPanel.vue';

export default {
  name: 'replacementmonthlystatistics-report-view',
  components: { SubmitPanel, YearMonthPanel, EmployeesPanel },
  props: {
    employeeNumber: {
      type: Number,
      required: undefined,
    }
  },
  data: () => ({
    year: undefined,
    month: undefined,
    employeeId: undefined,
  }),
  async mounted() {

  },
  methods: {
    ...mapActions('reportStore', ['getMonthReport']),
    async performLookup() {
      const dto = {
        year: this.year,
        month: this.month,
        forUser: this.employeeId
      }
      await this.getMonthReport(dto);
    }
  },
  computed: {
    ...mapGetters('reportStore', ['monthReportApiState', 'monthReport']),
    loading() {
      return this.monthReportApiState === APISTATE.LOADING;
    }
  }
}
</script>
